import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import Button from '../buttons/Button';
import UploadDragDropFiles from '../upload-drag-drop-files/UploadDragDropFiles';
import validateFile from './../../services/validateFile';
import FileList from '../file-list/FileList';


const Funds = ( props ) => {
    let [ buttonError, setButtonError ]             = useState(false);
    let [ buttonText, setButtonText ]               = useState("Wczytaj / Przeciągnij plik z wykazem środków trwałych");
    let [ disabledButton, setDisabledButton ]       = useState(false);    
    let [ update, setUpdate ]             = useState(0);
    const dispatch                        = useDispatch()
    let fundsFiles                        = useSelector(state => state.fundsFiles)
    let fundsItems                        = useSelector(state => state.fundsItems)
    let [ updateArray, setUpdateArray ]   = useState(0);
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }

      useEffect(() => {
          setUpdate(update + 1);
      }, [fundsFiles]);

      let setFiles = (val) => {
        let files = fundsFiles;
        for (let i = 0; i < val.length; i++) {
            const el = val[i];
            let validate = validateFile(1048576, 2, files.length, el);
            setButtonError( validate.error )
            setButtonText( validate.message )
            if ( !validate.error ) {
              files.push(el);
            }
        }          
        dispatch({ type: 'FUNDS_FILES_CHANGE', value: files })
        setUpdate(++update);
    }
      let removeFile = ( index ) => {
            let files = fundsFiles;
            files.splice( index, 1);   
            dispatch({ type: 'FUNDS_FILES_CHANGE', value: files })
            setUpdate(--update);
            setButtonError( false )
            setButtonText( 'Przeciągnij plik / <br /> Wczytaj z dysku' )
    }

      let add = () => {
        let item = {
                "name": '',
                "productionYear": '',
                "price": '',
            }
        let copy = fundsItems;

        if ( copy.length < 5 ) {
            copy = [...copy, item];
            dispatch({ type: 'FUNDS_ITEMS_CHANGE', value: copy })
            setDisabledButton(false);
        }
        if ( copy.length === 5 ) {
            setDisabledButton(true);
        }
      }

    
    let updateValue =  async( val, index, property ) => {
        let copyArray = fundsItems;
        copyArray[index][property] = val;
        await dispatch( {type: 'FUNDS_ITEMS_CHANGE', value:  copyArray } )
        await setUpdateArray(++updateArray);
    }
    let removeLastFromArray = async () => {
        let copyArray = fundsItems;
        await copyArray.splice(-1, 1);
        await dispatch({ type: 'FUNDS_ITEMS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }
    return (
        <div className="real-estates">
            <Heading title="POSIADANE ŚRODKI TRWAŁE" medium />
            <div className="row">
                {/* <Heading title="Dodaj wykaz środków trwałych" /> */}
                { update && update >= 0 &&
                    <UploadDragDropFiles setFunction={ ( val ) => setFiles(val)  }
                        buttonText={ buttonText }
                        error={ buttonError } 
                        update={update}
                        tip={ true } 
                        tipHeader="Wczytaj plik"
                        tipText="Wczytaj plik w formacie .jpg lub .pdf. Waga pojedynczego pliku nie może być większa niż 1MB. Maksymalnie można załączyć 2 pliki." /> 
                }
                { fundsFiles.length > 0  &&
                    <FileList   update={ update } 
                                files={ fundsFiles }
                                remove={ ( val ) => removeFile( val ) } />
                }
                <Heading title="lub uzupełnij dane posiadanego środka trwałego" small />
                <div className="items">
                    { updateArray >= 0 && fundsItems && fundsItems.map((item, index) => (
                        <>
                        {index > 0 &&
                            <div className="line big" />
                        }
                        <div className="inputs">
                            <div className="col">
                                <Input name={"name-"+index}
                                    id={"founds-name-"+index}
                                    required={ false }
                                    setFunction={ val => updateValue(val, index, 'name') }
                                    type="text"
                                    placehold={ "Opis (nazwa)" }
                                    val={ item.name }
                                    size="xxl" 
                                    regExp={ null }
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                            <div className="col">
                                <Input name={"production-year-"+index}
                                    id={"founds-production-year-"+index}
                                    required={ false }
                                    setFunction={ val => updateValue(val, index, 'productionYear') }
                                    type="text"
                                    placehold={ "Rok produkcji" }
                                    val={ item.productionYear }
                                    size="xxl" 
                                    regExp={ null }
                                    minChar={ 0 } 
                                    regExp={/([12]\d{3})/}
                                    allowChars={/^[0-9-]{0,4}$/}
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                            <div className="col">
                                <Input name={"price-"+index}
                                    id={"founds-price-"+index}
                                    required={ false }
                                    setFunction={ val => updateValue(val, index, 'price')}
                                    type="text"
                                    placehold={ "Wartość rynkowa" }
                                    val={ item.price }
                                    formatPrice={ true }
                                    regExp={/^[0-9]{0,3}[\s?]{0,}[0-9]+([\,\.]{0,1}[0-9]{1,2}){0,1}$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    size="xxl" 
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                        </div>
                        </>
                    ))}
                </div>
                {/* { !disabledButton &&
                    <div className="add-real-eastate">
                        <Button title="Dodaj środek trwały" class="blue reverse" add={ true } setFunction={ () => add() } />
                    </div>
                } */}
                <div className="btns-real-estates">
                    { !disabledButton &&
                        <div className="col">
                            <div className="add-real-eastate">
                                <Button title="Dodaj środek trwały" class="blue reverse" add={ true } setFunction={ () => add() } />
                            </div>
                        </div>
                    }
                    { fundsItems.length >= 1 &&
                        <div className="col">
                            <Button title="Usuń środek trwały" class="blue reverse" minus={ true } setFunction={ () => removeLastFromArray() } />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Funds;